import { createContext, useContext } from 'react';
import { emptySession, SessionContextPayload } from '@Contexts/session/types';

export const SessionContext = createContext<SessionContextPayload>({
    current: emptySession,
    update: () => {},
    partnerships: [],
    setPartnerships: () => {},
});

export function useSession() {
    return useContext(SessionContext);
}
